import React from 'react';
import { Chip } from '@mui/material';

const getStatusStyles = (isActive: boolean) => {
  return isActive
    ? {
        label: 'Active',
        color: '#2e7d32',
        bg: '#e8f5e9',
        border: '1px solid #a5d6a7',
      }
    : {
        label: 'Inactive',
        color: '#c62828',
        bg: '#ffebee',
        border: '1px solid #ef9a9a',
      };
};

const StatusCellRenderer = (props: any) => {
  const isActive = props.value;
  const { label, color, bg, border } = getStatusStyles(isActive);

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: bg,
        color,
        border,
        fontWeight: 500,
        fontSize: '0.75rem',
        borderRadius: '999px',
        px: 2,
        height: '24px',
        letterSpacing: '0.3px',
        fontFamily: 'inherit',
        boxShadow: 'none',
      }}
    />
  );
};

export default StatusCellRenderer;
